(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("process"));
	else if(typeof define === 'function' && define.amd)
		define(["process"], factory);
	else if(typeof exports === 'object')
		exports["parallel-es"] = factory(require("process"));
	else
		root["parallel-es"] = factory(root["process"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_160__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition